import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {PublicLandingPageRoutingModule} from "./public-landing-page-routing.module";
import {LandingPageComponent} from "./components/landing-page/landing-page.component";
import {LandingPagesModule} from "fello-common";

@NgModule({
  declarations: [LandingPageComponent],
  imports: [CommonModule, PublicLandingPageRoutingModule, LandingPagesModule]
})
export class PublicLandingPageModule {}
